import { getItemFromArrayByKey } from 'U'

export default {
  namespaced: true,
  state: {
    areaMap: {},
    dictMap: {},
    deptMap: {},
    liftpropertyMap: {},
  },
  mutations: {
    addArea(state, payload) {
      state.areaMap[payload.key] = payload.data;
    },
    resetArea(state) {
      state.areaMap = {};
    },
    addDict(state, payload) {
      state.dictMap[payload.key] = payload.data;
    },
    resetDict(state) {
      state.dictMap = {};
    },
    addDept(state, payload) {
      state.deptMap[payload.key] = payload.data;
    },
    resetDept(state) {
      state.deptMap = {};
    },
    addProperty(state, payload) {
      state.liftpropertyMap[payload.key] = payload.data;
    },
    resetProperty(state) {
      state.liftpropertyMap = {};
    },
  },
}